export const DefaultTransitionDurations = {
  lg: '600ms' as const,
  md: '300ms' as const,
  sm: '150ms' as const,
}

export type TransitionDurations = typeof DefaultTransitionDurations
